module.exports = __webpack_public_path__ + "static/r_barc-48e7f55517894b98d33053764315cd99.jpg";